import { cn } from '../../utils/cn';

interface GradientButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    wrapperClassName?: string;
    children?: React.ReactNode | React.ReactNode[];
}

const GradientButton: React.FC<GradientButtonProps> = ({
    className = '',
    wrapperClassName,
    children,
    disabled,
    ...props
}) => {
    return (
        <div
            className={cn(
                'group relative rounded-lg p-px bg-gradient-to-r from-custom-green-start to-custom-green-end flex items-center justify-center h-12 w-full',
                disabled && 'opacity-50 cursor-not-allowed pointer-events-none', wrapperClassName
            )}
        >
            <div className='absolute z-10 inset-px group-focus-within:inset-[2px] rounded-lg bg-custom-green-900' />
            <button
                disabled={disabled}
                className={cn(
                    'absolute z-20 inset-0 flex items-center justify-center text-white text-sm rounded-lg px-4 py-3 gap-1 disabled:cursor-not-allowed bg-none group-hover:bg-custom-gray-overlay !outline-none font-helvetica',
                    className
                )}
                {...props}
            >
                {children}
            </button>
        </div>
    );
};

export default GradientButton;
